export const searchLeads = (payload) => ({ payload, type: 'SEARCH_LEADS' });
export const setLeads = (payload) => ({ payload, type: 'SET_LEADS' });

export const revealLeads = (payload) => ({ payload, type: 'REVEAL_LEADS' });
export const setRevealedLeads = (payload) => ({ payload, type: 'SET_REVEALED_LEADS' });

export const setInCrmMap = (payload) => ({ payload, type: 'SET_IN_CRM_MAP' });

export const setLeadsFilters = (payload) => ({ payload, type: 'SET_LEADS_FILTERS' });
export const getLeadsFilterOptions = () => ({ type: 'GET_LEADS_FILTER_OPTIONS' });
export const setLeadsFilterOptions = (payload) => ({ payload, type: 'SET_LEADS_FILTER_OPTIONS' });
export const clearLeadsSearch = () => ({ type: 'CLEAR_LEADS_SEARCH' });
export const setLeadsLoading = (payload) => ({ payload, type: 'SET_LEADS_LOADING' });
export const setRevealLoading = (payload) => ({ payload, type: 'SET_REVEAL_LOADING' });
export const setLeadsError = (payload) => ({ payload, type: 'SET_LEADS_ERROR' });

export const getLeadsCredits = () => ({ type: 'GET_LEADS_CREDITS' });
export const setLeadsCredits = (payload) => ({ payload, type: 'SET_LEADS_CREDITS' });
